import React, {useEffect, useRef} from "react";
import {HeaderComponent} from "../../components/common/header/HeaderComponent";
import {ButtonComponent} from "../../components/common/button/ButtonComponent";
import {useNavigate, useParams} from "react-router-dom";
import {RouteParam} from "../../types/types";
import './TakeSelfie.scss'
import {useThemedIcons} from "../../components/common/theme-provider/hooks/useThemedIcons";
import {ManuallySkipStepViewModel} from "../../viewmodel/manually-skip-step/ManuallySkipStepViewModel";
import {VerificationStepType} from "../../domain/verification/VerificationStepType";

export const TakeSelfiePage: React.FC = () => {

    const { verificationId } = useParams<RouteParam>();
    const navigate = useNavigate();
    const { icons } = useThemedIcons()
    const { manuallySkipStep } = ManuallySkipStepViewModel()
    const skipped = useRef(false)

    const navigateToSelfie = () => {
        navigate(`/${verificationId}/selfie`)
    }

    useEffect(() => {
        if (verificationId && !skipped.current) {
            skipped.current = true
            manuallySkipStep(VerificationStepType.DOC_NFC, verificationId)
        }
    }, [verificationId, manuallySkipStep]);

    return (
        <div className={`background background-white general-container information-container height-window`}>
            <HeaderComponent
                title="Take a selfie"
                subtitle="To make sure your ID matches you, please take a quick selfie"
                progress={60}/>
            <div className={`width-full take-selfie-icon flex-center`}>
                {icons.selfie}
            </div>

            <div className={`information-container-button take-selfie-button width-full`}>
                <ButtonComponent label="Start camera" onButtonClick={() => navigateToSelfie()} />
            </div>
        </div>
    )

}